var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaidLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 48,
    viewBox: "0 0 126 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_208_2824)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2471 16.2676C65.1901 15.3786 63.3861 14.9346 60.8341 14.9346H55.0781V32.7226H59.3821V27.1476H61.3101C63.6501 27.1476 65.3661 26.6326 66.4581 25.6016C67.6881 24.4466 68.3071 22.9086 68.3071 20.9886C68.3071 18.9976 67.6201 17.4236 66.2471 16.2676ZM61.2031 23.1226H59.3821V18.9596H61.0181C63.0081 18.9596 64.0031 19.6576 64.0031 21.0536C64.0031 22.4316 63.0691 23.1226 61.2031 23.1226ZM75.6721 14.9336H71.1841V32.7216H80.8741V28.6956H75.6721V14.9336ZM89.6671 14.9336L82.6171 32.7216H87.4491L88.3731 30.1356H94.4991L95.3441 32.7216H100.23L93.2301 14.9336H89.6671ZM89.6141 26.5346L91.4631 20.4546L93.2831 26.5346H89.6141Z",
    fill: "#111111"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_208_2824",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 126,
    height: 48
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 47.473H126V0H0V47.473Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_208_2824)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.473 32.722H106.962V14.934H102.473V32.722ZM124.39 18.268C123.823 17.4458 123.095 16.7474 122.25 16.215C120.895 15.361 119.046 14.935 116.705 14.935H110.791V32.722H117.709C120.209 32.722 122.215 31.905 123.729 30.269C125.243 28.634 125.999 26.464 125.999 23.761C125.999 21.611 125.463 19.78 124.39 18.268ZM117.207 28.695H115.28V18.961H117.234C118.607 18.961 119.662 19.391 120.402 20.248C121.142 21.105 121.512 22.321 121.512 23.895C121.512 27.095 120.077 28.695 117.207 28.695ZM18.637 0L4.09 3.81L0.081 18.439L5.095 23.587L0 28.65L3.773 43.343L18.257 47.39L23.353 42.326L28.367 47.473L42.914 43.663L46.922 29.033L41.909 23.887L47.004 18.824L43.231 4.13L28.745 0.083L23.651 5.146L18.637 0ZM9.71 6.624L17.373 4.616L20.724 8.056L15.837 12.912L9.71 6.624ZM26.532 8.102L29.937 4.719L37.567 6.851L31.34 13.038L26.532 8.102ZM4.672 17.238L6.783 9.533L12.908 15.821L8.022 20.677L4.672 17.237V17.238ZM34.219 15.995L40.446 9.806L42.432 17.546L39.028 20.93L34.219 15.995ZM18.717 15.868L23.604 11.012L28.411 15.948L23.525 20.804L18.717 15.868ZM10.903 23.633L15.789 18.777L20.599 23.713L15.711 28.569L10.903 23.633ZM26.406 23.76L31.292 18.904L36.1 23.84L31.213 28.696L26.406 23.76ZM4.57 29.927L7.976 26.542L12.783 31.479L6.558 37.665L4.57 29.927ZM18.591 31.525L23.478 26.669L28.286 31.605L23.4 36.461L18.591 31.525ZM34.093 31.653L38.98 26.797L42.331 30.236L40.221 37.941L34.093 31.653ZM9.437 40.623L15.663 34.434L20.473 39.37L17.067 42.755L9.437 40.623ZM26.28 39.417L31.166 34.561L37.292 40.85L29.63 42.857L26.28 39.417Z",
    fill: "#111111"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_208_2824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaidLogo);
export default __webpack_public_path__ + "static/media/plaid-logo.c40f2578adf7f85bce5c68d5eb6ab240.svg";
export { ForwardRef as ReactComponent };